import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const api = axios.create({
  baseURL: baseURL, // Changed from: baseURL: `${baseURL}/api`
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("journi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});